module.exports = __webpack_public_path__ + "img/bootstrap.11219306.svg";